<!--<iframe src="https://www.kryptomon.co/merchandise" class="merchandise"></iframe>-->
<div *transloco="let t;" class="merchandise-section gap-6">
  <div class="col col-lg-6 w-full md:w-1/2">
    <div class="merch-selector-card tabs">
      <div class="kind-tabs-container">
        <div class="king-tab uppercase" (click)="chooseKind(true)" [ngClass]="{'selected':custiomizableKind}"
          *ngIf="kryptomonsV2.length>0">
          {{t('merchandise.customizedDesign')}}
        </div>
        <div class="king-tab uppercase" *ngIf="kryptomonsV2.length==0" (click)="onlyForOwner()">
          {{t('merchandise.customizedDesign')}}
        </div>
        <div class="king-tab uppercase" (click)="chooseKind(false)" [ngClass]="{'selected':!custiomizableKind}">
          {{t('merchandise.fixedDesign')}}
        </div>
      </div>
      <div class="kind-tab-content">
        <span>{{t('merchandise.pickModel')}}</span>
        <div class="merch-selector-container">
          <div class="merch-selector-item" *ngFor="let merch of merchandise; let i = index " (click)="selectMerch(i)"
            [ngClass]="{'selectedMerch': merch.selected}">
            <img src="{{merch.defaultImg}}" />
          </div>
        </div>
      </div>
    </div>
    <div class="merch-selector-card">
      <span>{{t('merchandise.selectColor')}} &amp; {{t('merchandise.size')}}</span>
      <div class="merch-selector-container">
        <div class="merch-selector-card-select" *ngIf="selectedMerch!=undefined">
          <select [(ngModel)]="selectedColor" (ngModelChange)="checkSizes()">
            <option disabled value='def'>{{t('merchandise.selectColor')}}</option>
            <option *ngFor="let sm of selectedMerch.colors" [value]="sm">{{sm}}</option>
          </select>
        </div>
        <div class="merch-selector-card-select" *ngIf="selectedMerch!=undefined">
          <select [(ngModel)]="selectedSize">
            <option selected disabled value='def'>{{t('merchandise.selectSize')}}</option>
            <option *ngFor="let sm of selectedMerch.sizes" [value]="sm">{{sm}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="kryptomon-selector-card" *ngIf="custiomizableKind">
      <div class="kryptomon-selector-card-title">{{t('merchandise.selectYourKryptomon')}}</div>
      <div class="kryptomon-selector-card cards">
        <div class="other-card" *ngFor="let kr of parsedKryptomon; let i = index" (click)="selectKryptomon(i)"
          [ngClass]="{'selectedKryptomon':kr.selected}">
          <div class="other-card-img">
            <img src="{{kr.data.image}}" />
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <span>{{kr.data.name}}</span>
            </div>
            <div class="other-card-rating">
              <div class="Stars" style="--rating: {{kr.data.starValue}}"></div>
              {{kr.data.tierName}}
            </div>
            <span>{{t('shared.speciality')}}: {{kr.data.speciality}}</span>
            <div class="other-card-icons">
              <div class="other-card-element">
                <img src="{{kr.data.mainFamilyImage}}" />
              </div>
              <div class="other-card-element">
                <img src="{{kr.data.secondaryFamilyImage}}" />
              </div>
              <div class="other-card-breed" *ngIf="kr.data.breedingTotal">
                <img src="./assets/img/Icon/Heart.png" />
                {{kr.data.breedingDone}}/{{kr.data.breedingTotal}}
              </div>
              <div class="other-card-sex">
                <img src="{{kr.data.genderIcon}}" />
              </div>
              <div class="other-card-gen">
                GEN: {{kr.data.genes.generation}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col col-lg-6 w-full md:w-1/2">
    <div class="mockup-container">
      <div class="mockup-image-base">
        <img class="mockup-image-base-img" src="{{selectedImageBase}}" />
        <div class="mockup-image-kryptomon {{selectedMerch.type}}">
          <img src="{{selectedKryptomonImage}}" />
          <p>{{selectedKryptomonId}}</p>
        </div>
      </div>
    </div>
    <div class="quantity-selector-card">
      <div class="selector-quantity">
        <div class="selector-item" (click)="changeQuantity('plus')">
          +
        </div>
        <div class="selector-amount">
          {{selectedQuantity}}
        </div>
        <div class="selector-item" (click)="changeQuantity('minus')">
          -
        </div>
      </div>
      <div class="toggle-item-container" *ngIf="isJunior && custiomizableKind">
        <div class="toggle-item">
          <input type="checkbox" id="switch_sale" [checked]="isBabyImage" /><label for="switch_sale"
            (click)="toggleBaby()">sale_toggle</label>{{t('shared.baby')}}
        </div>
      </div>
      <div class="action-buttons">
        <div class="button-gradient" (click)="addToCart()"
          *ngIf="(selectedKryptomonImage && selectedKryptomonId && selectedSize && selectedColor && selectedQuantity>0 && selectedSize!=='def' && selectedColor!=='def') || (!custiomizableKind && selectedSize!=='def' && selectedColor && selectedQuantity>0)">
          {{t('merchandise.addToCart')}}
        </div>
        <div class="button-gradient disabled"
          *ngIf="(!selectedKryptomonImage || !selectedKryptomonId || !selectedSize || selectedSize=='def' || !selectedColor || selectedQuantity<=0) && custiomizableKind">
          {{t('merchandise.addToCart')}}
        </div>
        <div class="button-gradient disabled"
          *ngIf="(!selectedSize || selectedSize=='def' || !selectedColor || selectedQuantity<=0) && !custiomizableKind">
          {{t('merchandise.addToCart')}}
        </div>
      </div>
    </div>
    <div class="line-divider"></div>
    <div class="cart-card">
      <!--<h1>Cart</h1>-->
      <div class="cart-container" *ngIf="cartObject.cartArray.length>0">
        <div class="cart-scroll">
          <div class="cart-item" *ngFor="let item of cartObject.cartArray; let i = index">
            <div class="cart-item-content">
              <div class="cart-item-img">
                <img src="{{item.image}}" />
              </div>
              <div class="cart-item-details">
                <p class="cart-item-title">{{item.title}}</p>
                <div class="cart-item-size">
                  <span>{{t('merchandise.size')}}: {{item.size}}</span><span>-</span><span>{{item.quantity}}</span>
                </div>
              </div>
            </div>
            <div class="cart-item-quantity-action">
              <span class="title-gradient gradient-pp"><img src="./assets/img/Home/k-logo.png" />
                {{item.priceKMON.toLocaleString()}}</span>
              <span class="cart-item-trash" (click)="removeFromCart(i)">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </span>
            </div>
          </div>
          <div class="cart-item delivery">
            <div class="cart-item-content">
              <div class="cart-item-img">
                <!--<img src="{{item.image}}" />-->
              </div>
              <div class="cart-item-details">
                <!--<p class="cart-item-title">International Shipment</p>-->
                <div class="cart-item-size">
                  <span>{{t('merchandise.internationalShipment')}}</span>
                </div>
              </div>
            </div>
            <div class="cart-item-quantity-action">
              <span class="title-gradient gradient-pp"><img src="./assets/img/Home/k-logo.png" />
                {{deliveryPrice.toLocaleString()}}</span>
            </div>
          </div>
        </div>
        <div class="cart-actions">
          <div class="total-price">
            {{t('shared.total')}}: <img src="./assets/img/Home/k-logo.png" />{{cartObject.totalPrice.toLocaleString()}}
          </div>
          <div class="button-gradient" (click)="showAddressForm = true"
            *ngIf="cartObject.cartArray.length>0 && !notEnoughKmon && !reloadSession">
            {{t('shared.buy')}}
          </div>
          <div class="button-gradient disabled" *ngIf="cartObject.cartArray.length == 0 && !reloadSession">
            {{t('shared.buy')}}
          </div>
          <div class="button-outline" *ngIf="cartObject.cartArray.length > 0 && notEnoughKmon && !reloadSession"
            (click)="openKmonWallet()">
            {{t('merchandise.refillWallet')}}
          </div>
          <div class="button-outline" (click)="gotoLogin()" *ngIf="reloadSession">
            {{t('errorMsg.sessionExpired')}}
          </div>
        </div>
      </div>
      <div class="cart-container empty" *ngIf="cartObject.cartArray.length==0">
        <img class="icon-emptyItem" src="./assets/img/Icon/Merchandise-NoItem.svg" />
        <span>{{t('merchandise.noItemInCart')}}</span>
      </div>
    </div>
  </div>
  <div class="merchandise-form-overlay" *ngIf="showAddressForm">
    <fa-icon [icon]="['fas', 'times']" (click)="showAddressForm=!showAddressForm; isSuccess=false"
      class="close-icon"></fa-icon>
    <form class="merchandise-form" [formGroup]="merchandiseForm" *ngIf="!isSuccess">
      <span class="mb-4 text-2xl">{{t('merchandise.insertDeliveryAddress')}}</span>
      <input type="text" [placeholder]="t('merchandise.fullName')" formControlName="fullName">
      <input type="text" [placeholder]="t('merchandise.address')" id="addressForm" gmapAutocomplete
        (setAddress)="getGmapsAddress($event)" formControlName="address" class="form-control" [options]="options">
      <input type="text" [placeholder]="t('merchandise.streetNumber')" formControlName="streetNumber">
      <input type="text" [placeholder]="t('merchandise.city')" formControlName="city">
      <input type="text" [placeholder]="t('merchandise.stateProvince')" formControlName="stateProvince">
      <input type="text" [placeholder]="t('merchandise.country')" formControlName="country">
      <input type="text" [placeholder]="t('merchandise.postalCode')" formControlName="postalCode">
      <input type="tel" placeholder="+44 12345679" formControlName="phone">
      <input type="text" placeholder="CPF/CNPJ" formControlName="taxNumber"
        [ngClass]="{'hidden_input':merchandiseForm.get('country').value!=='BR'}">
      <div class="action-buttons">
        <k-button type="submit" (click)="checkDeliveryInfos()" [isDisabled]="!merchandiseForm.valid"
          [label]="t('merchandise.confirmPurchase')"></k-button>
        <!-- <div class="button-gradient" (click)="checkDeliveryInfos()" [isDisabled]="!merchandiseForm.valid">
          Confirm Purchase</div> -->
      </div>
    </form>

    <!-- <div class="merchandise-form" *ngIf="!isSuccess">
      <span>Insert your delivery address.</span>
      <input type="text" placeholder="Full Name" [(ngModel)]="fullName" required #fullnameFront="ngModel">
      <input type="text" placeholder="Address" id="addressForm" gmapAutocomplete (setAddress)="getGmapsAddress($event)"
        [(ngModel)]="address" class="form-control" [options]="options" required #addressFront="ngModel">
      <input type="text" placeholder="Street Number" [(ngModel)]="streetNumber" required #streetNumberFront="ngModel">
      <input type="text" placeholder="City" [(ngModel)]="city" required #cityFront="ngModel">
      <input type="text" placeholder="State/Province" [(ngModel)]="stateProvince" required
        #stateProvinceFront="ngModel">
      <input type="text" placeholder="Country" [(ngModel)]="country" required #countryFront="ngModel">
      <input type="text" placeholder="Postal Code" [(ngModel)]="postalCode" required #postalCodeFront="ngModel">
      <ngx-intl-tel-input [cssClass]="'custom'" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [maxLength]="15" [phoneValidation]="true" [(ngModel)]="phone" [separateDialCode]="true"></ngx-intl-tel-input>
      <input type="tel" placeholder="+44" [(ngModel)]="phone" required #phoneFront="ngModel">
      <input type="text" placeholder="CPF/CNPJ" [(ngModel)]="taxNumber" required #taxNumberFront="ngModel"
        [ngClass]="{'hidden_input':country!=='BR'}">
      <div class="action-buttons">
        <div class="button-gradient" (click)="checkDeliveryInfos()"
          *ngIf="!fullnameFront.errors && !addressFront.errors && !streetNumberFront.errors && !cityFront.errors && !stateProvinceFront.errors && !countryFront.errors && !postalCodeFront.errors && !isLoading && !isSuccess && phoneFront.length>=8 && country!=='BR'">
          Confirm Purchase1</div>
        <div class="button-gradient" (click)="checkDeliveryInfos()"
          *ngIf="!fullnameFront.errors && !addressFront.errors && !streetNumberFront.errors && !cityFront.errors && !stateProvinceFront.errors && !countryFront.errors && !postalCodeFront.errors && !isLoading && !isSuccess && phoneFront.length>=8 && country=='BR' && !taxNumberFront.errors">
          Confirm Purchase2</div>
        <div class="button-gradient disabled"
          *ngIf="(fullnameFront.errors || addressFront.errors || streetNumberFront.errors || cityFront.errors || stateProvinceFront.errors || countryFront.errors || postalCodeFront.errors || (taxNumberFront.errors && country=='BR') || phoneFront.length<8) && (!isLoading && !isSuccess)">
          Confirm Purchase3</div>
        <div class="button-gradient" *ngIf="!isLoading && isSuccess">
          <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </div>
        <div class="button-gradient" *ngIf="isLoading && !isSuccess">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
      </div>
    </div> -->
    <div class="merchandise-form" *ngIf="isSuccess">
      <img src="./assets/img/Icon/Merchandise-Confirmed.svg" class="shopping-bag" />
      <h1>{{t('merchandise.yourOrder')}}<br /><span class="title-gradient gradient-pp">has been confirmed!</span></h1>
      <p>{{t('merchandise.emailWithDetails')}}</p>
      <div class="action-buttons">
        <div class="button-outline" (click)="showAddressForm=!showAddressForm; isSuccess=false;">Close</div>
      </div>
    </div>
  </div>
</div>